// extracted by mini-css-extract-plugin
export default {"secondarySpan":"SecondarySpan_secondarySpan__Vylus"};